module.exports = __webpack_public_path__ + "static/media/recent-order-active.c4e4597f.svg";